import kyeCanvasTable from './canvas-table.vue'

export default kyeCanvasTable



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/index.js